const isUserAgentWebKit = () =>
  navigator.userAgent.includes('AppleWebKit');

// https://stackoverflow.com/a/66635231/13136284
const supportsTouch = () =>
  'ontouchstart' in window
  || navigator.maxTouchPoints > 0
  || navigator.msMaxTouchPoints > 0;

export const isMobileWebKit = () => isUserAgentWebKit() && supportsTouch();
